// extracted by mini-css-extract-plugin
export var FrontPage__searchBtn = "FrontPage-module--FrontPage__search-btn--3Ad-L";
export var FrontPage__soundBtn = "FrontPage-module--FrontPage__sound-btn--w-jWD";
export var FrontPage__langBtn = "FrontPage-module--FrontPage__lang-btn--a2ldA";
export var transparentBoothArea = "FrontPage-module--transparentBoothArea--25ULh";
export var linkLineloop = "FrontPage-module--link-lineloop--3roLg";
export var keyGnav = "FrontPage-module--key-gnav--OkmN2";